export const nameRegexp = /^[a-zA-Z'\s.-]+$/
export const numberRegex = /^\d+$/;
export const camelCaseRegexp = /([a-z](?=[A-Z]))/g
export const linkRegex = /https?:\/\/\S+/g
